import { render, staticRenderFns } from "./AnosafraPercentagesForm.vue?vue&type=template&id=4889a769&scoped=true"
import script from "./AnosafraPercentagesForm.vue?vue&type=script&lang=js"
export * from "./AnosafraPercentagesForm.vue?vue&type=script&lang=js"
import style0 from "./AnosafraPercentagesForm.vue?vue&type=style&index=0&id=4889a769&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4889a769",
  null
  
)

export default component.exports